/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

export const STORE_INSTALLATION_STATES: Record<string, string> = {
  ok: 'connected',
  down: 'disconnected',
  invalid_auth: 'invalid_auth',
  unknown: 'unknown',
};

export const STORE_INSTALLATION_STATES_STAMP_COLOR: Record<string, string> = {
  connected: 'green',
  disconnected: 'red',
  invalid_auth: 'yellow',
  unknown: 'gray',
};

export default class ShopifyIntegration extends Model {
  @service intl!: IntlService;

  @attr('string') declare intercom_app_id: string;
  @attr('string') declare shopId: string;
  @attr('string') declare shopifyDomain: string;
  @attr('string') declare installationStatus: string;

  get stampLabel() {
    return this.intl.t(
      `appstore.settings.shopify.connect-shopify.status-label.${this.getStoreStatus()}`,
    );
  }

  get stampColor() {
    let stampColor = STORE_INSTALLATION_STATES_STAMP_COLOR[this.getStoreStatus()];
    return stampColor || 'gray';
  }

  getStoreStatus() {
    if (!this.installationStatus) {
      return 'unknown';
    }

    return STORE_INSTALLATION_STATES[this.installationStatus.toLowerCase()] || 'unknown';
  }

  get analyticsData() {
    return {
      object: 'shopify_integration',
      shopify_integration_id: this.id,
    };
  }
}
